/* eslint-disable max-len */
import { GetIAMAvailableModulesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/available_modules/response/GetIAMAvailableModulesResponse';
import { APP_NAMESPACE } from 'app/App.constants';
import { NO_DATA } from 'utils';

export const IAM_MODULES_NAMESPACE = `${APP_NAMESPACE}/IAM_MODULES`;
export const GET_IAM_AVAILABLE_MODULES_REQUEST = `${IAM_MODULES_NAMESPACE}/GET_IAM_AVAILABLE_MODULES_REQUEST`;

export interface IamModulesState {
  availableModules: NO_DATA | GetIAMAvailableModulesResponse;
}
